<template>
  <section class="layout-section" v-for="(column, i) in section" :key="i">
    <LayoutColumn v-if="typeof column === 'object' && Object.keys(column).length" :column="column" :context="context" />
  </section>
</template>

<script setup>
defineProps({
  section: { type: Object, required: true, default: () => ({}) },
  context: { type: Object, required: false, default: () => ({}) },
})
</script>

<style scoped>
.layout-section {
  display: flex;
  gap: var(--offset);
  margin-bottom: 6rem;
}

@media (max-width: 768px) {
  .layout-section { flex-direction: column; }
}
</style>
